import { ITableGridFilter } from './types'
import { deepRemoveEmptyFields, QueryParam } from '../utils'

export interface ITableGridQueryParams {
  table?: string
}

export interface IUrlQueryParamOptions<T> {
  defaultFilter?: ITableGridFilter<T>
}

class UrlQueryParamBase {
  getUrlQuery = <T>(options?: IUrlQueryParamOptions<T>) => {
    try {
      const query = QueryParam.gets<ITableGridQueryParams>('table')
      return query.table ? JSON.parse(query.table) : options?.defaultFilter
    } catch (error) {
      return options?.defaultFilter
    }
  }

  setUrlQuery = <T>(params: ITableGridFilter<T>, options?: IUrlQueryParamOptions<T>) => {
    const filter = this.extractFilter(params, options)
    const filterRemovedEmpty = deepRemoveEmptyFields(filter)

    if (Object.keys(filterRemovedEmpty).length === 0) {
      return QueryParam.replaceDeletes<ITableGridQueryParams>('table')
    }
    QueryParam.replacePatch<ITableGridQueryParams>({ table: JSON.stringify(filterRemovedEmpty) })
  }

  extractFilter = <T>(filter: ITableGridFilter<T>, options?: IUrlQueryParamOptions<T>): ITableGridFilter<T> => {
    const dFilter: Partial<ITableGridFilter<T>> = options?.defaultFilter || {}
    const obj = { ...filter }
    delete obj.details
    delete obj.loading

    const checkPagination1 = obj.pagination?.page === dFilter.pagination?.page
    const checkPagination2 = obj.pagination?.pageSize === dFilter.pagination?.pageSize
    if (checkPagination1 && checkPagination2) delete obj.pagination

    return obj
  }
}

const UrlQueryParam = new UrlQueryParamBase()
export default UrlQueryParam
